import { Box, styled } from '@mui/material';
import { HelixPalette, HelixStyles } from '../../helix';
/**
 * Base styles for a nav bar item.
 */
const NavbarItemBase = {
    alignItems: 'center',
    backgroundColor: 'transparent',
    border: 'none',
    display: 'flex',
    padding: '0.5rem',
    width: '100%',
    ':focus': { outline: 'none' },
    ':hover': {
        cursor: 'pointer',
        backgroundColor: HelixPalette.neutral10,
    },
    ':active:focus': {
        backgroundColor: HelixPalette.neutral50,
        color: HelixPalette.neutral90,
    },
    '&[data-active="true"]': {
        backgroundColor: HelixPalette.teal80,
        'svg, h3, h4': { color: HelixPalette.white },
    },
    ':focus-visible': { outline: HelixStyles.focusVisible7.outline, outlineOffset: HelixStyles.focusVisible7.outlineOffset },
};
/**
 * Base styles for a parent nav bar item.
 */
const NavbarParentItemBase = Object.assign(Object.assign({}, NavbarItemBase), { borderRadius: '0.5rem', height: '2.5rem', h3: { marginLeft: '0.5rem' } });
/**
 * Base styles for a child and grand child nav bar item.
 */
const NavbarChildItemBase = Object.assign(Object.assign({}, NavbarItemBase), { borderRadius: '0.375rem', height: '1.5rem' });
/**
 * Styled Box for the nav bar inner container.
 */
export const NavbarContainer = styled(Box)(() => ({
    alignItems: 'stretch',
    backgroundColor: HelixPalette.neutral05,
    boxShadow: HelixStyles.elevationLG,
    display: 'flex',
    flexDirection: 'column',
    left: 0,
    position: 'fixed',
    zIndex: 997,
}));
/**
 * Styled ul for the parent menu.
 */
export const ParentMenuUL = styled('ul')(() => ({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    a: Object.assign(Object.assign({}, NavbarParentItemBase), { textDecoration: 'none' }),
    li: { marginTop: '0.5rem', '&:first-of-type': { marginTop: '0' } },
}));
/**
 * Styled ul for a child/grandchild menu.
 */
export const ChildMenuUL = styled('ul')(() => ({
    borderLeft: `1px solid ${HelixPalette.neutral50}`,
    listStyle: 'none',
    margin: '0 0 0 16px',
    padding: '0 0 0 12px',
    a: Object.assign(Object.assign({}, NavbarChildItemBase), { textDecoration: 'none' }),
    li: { marginTop: '0.5rem', '&:first-of-type': { marginTop: '0.5rem' } },
}));
/**
 * Styled button for the parent item.
 */
export const NavbarParentButton = styled('button')(() => (Object.assign({}, NavbarParentItemBase)));
/**
 * Styled button for a child/grandchild item.
 */
export const NavbarChildButton = styled('button')(() => (Object.assign({}, NavbarChildItemBase)));
/**
 * Styled button for the collapse/expand and search buttons
 */
export const NavbarButton = styled('button')(() => (Object.assign(Object.assign({}, NavbarItemBase), { width: 'auto', borderRadius: '0.5rem' })));
/**
 * Styled Box for the nav bar context.
 */
export const NavbarContext = styled(Box)(() => ({
    alignItems: 'center',
    display: 'flex',
    width: '100%',
    svg: { fontSize: '2rem' },
    h3: Object.assign(Object.assign(Object.assign({}, HelixStyles.style_03), HelixStyles.truncate), { fontWeight: 'bold' }),
}));
